import { useNavigate } from "react-router-dom";
import { visitNotesApi } from "../lib/apiClient";
import { VisitNoteForm } from "../components/VisitNoteForm";

export function VisitNoteNew() {
  const navigate = useNavigate();

  return (
    <div>
      <h1>New visit note</h1>
      <VisitNoteForm
        submitLabel="Create"
        onSubmit={async (input) => {
          const note = await visitNotesApi.create(input);
          navigate(`/visit-notes/${note.id}`);
        }}
      />
    </div>
  );
}
